import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

const base = (companyId) => `${companyId}/templates`;

/** Tenant templates + approved shared catalog entries. */
export const listTemplates = (companyId) =>
  axios.get(getApiUrl(base(companyId)), { withCredentials: true });

/**
 * Evaluate a template's debit/credit formulas using the supplied parameters
 * and return suggested transactions — { account_id, account_number, debit, credit, ... }.
 */
export const suggestFromTemplate = (companyId, templateId, parameters, userSelectedAccount = {}) =>
  axios.post(
    getApiUrl(`${base(companyId)}/${templateId}/suggestion`),
    { parameters, userSelectedAccount },
    { withCredentials: true },
  );
